import Cookies from 'js-cookie';
import ConfigCmsApi from '../configs/ConfigCmsApi';

const headers = () => ({ Authorization: Cookies.get('adminToken') });

const list = (params) => ConfigCmsApi.get('/operation-result-images/', {
  params,
  headers: headers(),
});

const upload = ({ clinicId, operationId, file, doctor_id, year, patient_age }) => {
  const formData = new FormData();
  formData.append('file', file);
  if (doctor_id) formData.append('doctor_id', doctor_id);
  if (year) formData.append('year', year);
  if (patient_age) formData.append('patient_age', patient_age);

  return ConfigCmsApi.post(
    `/operation-result-images/${clinicId}/upload/${operationId}`,
    formData,
    { headers: headers() }
  );
};

const update = ({ id, data }) => ConfigCmsApi.put(
  `/operation-result-images/${id}`,
  data,
  { headers: headers() }
);

const remove = (id) => ConfigCmsApi.delete(
  `/operation-result-images/${id}`,
  { headers: headers() }
);

export default { list, upload, update, remove };
